import { BulkActionCaseRelatedEntitiesType } from 'src/pages/BulkActionCaseRelatedEntitiesPage';
import { getCurrentStage } from 'src/utils/StageConfigUtils';
import { EntityType, STAGE } from './enums';

export enum ServiceConstants {
  GET = 'get',
  POST = 'post'
}

export const MAX_USER_IDS_LENGTH = 5;

const DEFAULT_TEMPLATE_NAME = 'bulk_template.csv';

export const BulkActionTypeToTemplateFileNameMap: Readonly<
  Record<BulkActionCaseRelatedEntitiesType, string>
> = Object.freeze({
  [BulkActionCaseRelatedEntitiesType.CREATE_CASE]: DEFAULT_TEMPLATE_NAME,
  [BulkActionCaseRelatedEntitiesType.CREATE_CASE_V2]:
    'create_case_v2_bulk_template.csv',
  [BulkActionCaseRelatedEntitiesType.CREATE_ASSET_V2]:
    'create_asset_v2_bulk_template.csv',
  [BulkActionCaseRelatedEntitiesType.UPDATE_CASE]: DEFAULT_TEMPLATE_NAME,
  [BulkActionCaseRelatedEntitiesType.UPDATE_CASE_V2]:
    'update_case_v2_bulk_template.csv',
  [BulkActionCaseRelatedEntitiesType.UPDATE_ASSET_V2]:
    'update_asset_v2_bulk_template.csv',
  [BulkActionCaseRelatedEntitiesType.DELETE_CASE]: 'delete_bulk_template.csv',
  [BulkActionCaseRelatedEntitiesType.GET_LEGAL_REPORT]: DEFAULT_TEMPLATE_NAME,
  [BulkActionCaseRelatedEntitiesType.SEND_EMAILS]: 'send_bulk_emails.csv',
  [BulkActionCaseRelatedEntitiesType.DEFAULT]: DEFAULT_TEMPLATE_NAME
});

export const BulkActionTypeToEntityTypeMap: Readonly<
  Record<BulkActionCaseRelatedEntitiesType, EntityType>
> = Object.freeze({
  [BulkActionCaseRelatedEntitiesType.CREATE_CASE]: EntityType.CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.CREATE_CASE_V2]: EntityType.CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.CREATE_ASSET_V2]: EntityType.ASSET_ENTITY,
  [BulkActionCaseRelatedEntitiesType.UPDATE_CASE]: EntityType.CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.UPDATE_CASE_V2]: EntityType.CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.UPDATE_ASSET_V2]: EntityType.ASSET_ENTITY,
  [BulkActionCaseRelatedEntitiesType.DELETE_CASE]:
    EntityType.DELETE_CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.GET_LEGAL_REPORT]: EntityType.CASE_ENTITY,
  [BulkActionCaseRelatedEntitiesType.SEND_EMAILS]: EntityType.EMAILS_ENTITY,
  [BulkActionCaseRelatedEntitiesType.DEFAULT]: EntityType.CASE_ENTITY
});

export const BulkActionTypeToCSVHeadersTypeMap: Readonly<
  Map<BulkActionCaseRelatedEntitiesType, Array<string>>
> = Object.freeze(
  new Map([
    [
      BulkActionCaseRelatedEntitiesType.CREATE_CASE_V2,
      [
        'useCase',
        'requesterType',
        'requesterId',
        'requesterIdType',
        'title',
        'description',
        'assigneeId',
        'assigneeType',
        'status',
        'concerningId',
        'concerningIdType',
        'concerningIsVisibleTo',
        'concerningType',
        'queueId'
      ]
    ],
    [
      BulkActionCaseRelatedEntitiesType.UPDATE_CASE_V2,
      [
        'useCase',
        'requesterType',
        'requesterId',
        'requesterIdType',
        'title',
        'description',
        'caseId'
      ]
    ],
    [
      BulkActionCaseRelatedEntitiesType.SEND_EMAILS,
      [
        'CaseId',
        'Template Unique Name',
        'Contact Email',
        'Contact AmazonEmail',
        'HRBP Email',
        'Hiring Manager Email',
        'Recruiter Email',
        'Skip Level Manager Email',
        ...(getCurrentStage() !== STAGE.PROD ? ['EmailOverride'] : [])
      ]
    ]
  ])
);
